<template>
  <div class="Game">
    <div class="tab_layout">
      <ul class="tab-title">
        <li class="tab-item" :class="{active:tabSelect==0}" @click="onSelectTab(0)" v-html="$t('我的游戏')"></li>
        <li class="tab-item" :class="{active:tabSelect==1}" @click="onSelectTab(1)" v-html="$t('链游')"></li>
        <li class="tab-item" :class="{active:tabSelect==2}" @click="onSelectTab(2)" v-html="$t('社区')"></li>
      </ul>
    </div>

    <div class="game_page" v-show="tabSelect==0">
      <iframe
          src="https://d58d0gyzx8chw.cloudfront.net/index.html?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOjE5NjQwMjU0NjE5MTg5MjQ4MSwiaWF0IjoxNjQ1NTk1MTQwfQ.YTuxCArGqR912s0bqlxLgdKEogD-N2tjgvk5VkuMz6o"
          frameborder="0"></iframe>
    </div>

    <div class="lian-you" v-show="tabSelect==1">
      <div class="image">
        <mt-swipe :auto="3000">
          <mt-swipe-item class="swipe_item"
                         v-for="(item,index) in banner" :key="index">
            <img class="slide_img" :src="item.image" alt="">
          </mt-swipe-item>
        </mt-swipe>
      </div>
      <!--      二级导航-->
      <div class="sub_nav">
        <ul>
          <li class="tab-item" :class="{active:subTabIndex==index}" @click="selectSubTab(index)"
              v-for="(item,index) in catList" :key="index">{{ item.type_name }}
          </li>
        </ul>
      </div>
      <!--    推荐的  显示推荐-->
      <div class="recommend_game" v-show="subTabIndex==0">
        <GameRecommend :recommend-list="recommendList"/>
      </div>
      <!--      游戏列表-->
      <div class="game_list">
        <div v-show="subTabIndex==0">
          <div class="item_game" @click="toDetail(item)"
               v-for="(item,index) in gameList1" :key="index">
            <img :src="item.icon" alt="">
            <p class="title">{{ item.name }}</p>
            <p class="tag">{{ typeName }}</p>
            <div class="btn_get">
              {{$t('获取')}}
            </div>
          </div>
        </div>
        <div v-show="subTabIndex==1">
          <div class="item_game" @click="toDetail(item)"
               v-for="(item,index) in gameList2" :key="index">
            <img :src="item.icon" alt="">
            <p class="title">{{ item.name }}</p>
            <p class="tag">{{ typeName }}</p>
            <div class="btn_get">
              {{$t('获取')}}
            </div>
          </div>
        </div>
        <div v-show="subTabIndex==2">
          <div class="item_game" @click="toDetail(item)"
               v-for="(item,index) in gameList3" :key="index">
            <img :src="item.icon" alt="">
            <p class="title">{{ item.name }}</p>
            <p class="tag">{{ typeName }}</p>
            <div class="btn_get">
              {{$t('获取')}}
            </div>
          </div>
        </div>
        <div v-show="subTabIndex==3">
          <div class="item_game" @click="toDetail(item)"
               v-for="(item,index) in gameList4" :key="index">
            <img :src="item.icon" alt="">
            <p class="title">{{ item.name }}</p>
            <p class="tag">{{ typeName }}</p>
            <div class="btn_get">
              {{$t('获取')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    社区-->
    <div class="community" v-show="tabSelect==2">
      <ul>
        <li @click="selectTrend(0)">
          <div :class="{active:trendIndex==0}" v-html="$t('全部动态')"></div>
        </li>
        <li @click="selectTrend(1)">
          <div :class="{active:trendIndex==1}" v-html="$t('我的关注')"></div>
        </li>
      </ul>
      <!--      全部动态-->
      <div v-show="trendIndex==0">
        <AllTrend/>
      </div>
      <!--      我的关注-->
      <div v-show="trendIndex==1">
        <MyAttend/>
      </div>

      <div class="add-trend" @click="addTrend()">
        <img src="../../assets/img/addTrend.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>

import {httpPostGameCate, httpPostGameList} from "../../api/game";
import GameRecommend from "./GameRecommend";
import {httpPostBanner} from "@/api/game";
import AllTrend from "../trend/AllTrend";
import MyAttend from "../trend/MyAttend";

export default {
  name: "Game",
  data() {
    return {
      tabSelect: 0,

      //banner图
      banner: [],

      //二级菜单
      subTabIndex: 0,

      //动态的
      trendIndex: 0,

      catList: [],//游戏分类
      type_id: 0,//当前类型ID

      recommendList: [],
      gameList1: [],
      gameList2: [],
      gameList3: [],
      gameList4: []
    }
  },
  components: {
    // GameIframe
    GameRecommend,
    AllTrend,
    MyAttend
  },
  watch: {},
  computed: {
    typeName: function () {
      return this.catList[this.subTabIndex].type_name
    }
  },
  mounted() {
    this.getBanner()
    this.getGameCate()
  },

  methods: {

    getBanner: function () {
      httpPostBanner()
          .then(res => {
            this.banner = res.data.list;
          })
          .catch(() => {
          });
    },
    //一级菜单选择
    onSelectTab(value) {
      this.tabSelect = value
    },
    //二级菜单选择
    selectSubTab(value) {
      this.subTabIndex = value
      this.type_id = this.catList[value].type_id
      this.getGameList({
        type_id: this.type_id,
        limit_begin: 0,
        limit_num: 10
      })
    },

    //动态
    selectTrend(value) {
      this.trendIndex = value
    },

    /**
     * 获取分类
     */
    getGameCate() {
      let that = this
      httpPostGameCate()
          .then(res => {
            this.catList = res.data.list.reverse().slice(0, 4);
            //默认显示第一项
            this.type_id = this.catList[0].type_id
            this.getGameList({
              type_id: that.type_id,
              limit_begin: 0,
              limit_num: 10
            })
          })
    },

    /**
     * 根据分类获取列表
     */
    getGameList(data) {
      httpPostGameList(data)
          .then(res => {
            switch (this.subTabIndex) {
              case 0:
                if (res.data.count > 5) {
                  this.recommendList = res.data.list.slice(0, 5)
                  this.gameList1 = res.data.list.slice(5)
                } else {
                  this.recommendList = res.data.list
                }
                break
              case 1:
                this.gameList2 = res.data.list
                break
              case 2:
                this.gameList3 = res.data.list
                break
              case 3:
                this.gameList4 = res.data.list
                break
            }

          })
    },

    toDetail: function (item) {
      let typeName = this.catList[this.subTabIndex].type_name
      this.$router.push({path: '/game_detail', query: {item: item, type: typeName}})
    },

    addTrend(){
      this.$router.push({path: '/add_trend'})
    }

  }


}
</script>

<style scoped lang="less">
.Game {
  //height: calc(100vh - 55px);
  height: 100%;
  padding-bottom: 55px;
  background:#fff;
}

.tab_layout {
  height: 50px;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  background: #fff;

  ul {
    overflow: hidden;
    padding-bottom: 2px;

    li {
      float: left;
      width: 33%;
      display: inline-block;
      text-align: center;
      line-height: 50px;
      font-size: 14px;
    }

    li.active {
      color: #4184d2;
      border-bottom: 2px solid #4184d2;
    }
  }

}

iframe {
  width: 100%;
  height: 100%;
}

//嵌套的网页
.game_page {
  height: 100%;
  padding-bottom: 55px;
  margin-top: 50px;
}


//链游部分
.lian-you {
  padding-bottom: 80px;
  margin-top: 50px;

  .image {
    height: 209px;

    .swipe_item {
      .slide_img {
        width: 100%;
        height: 209px;
      }
    }
  }

  .sub_nav {
    height: 59px;

    ul {
      overflow: hidden;

      li {
        float: left;
        width: 25%;
        text-align: center;
        line-height: 50px;
        font-size: 14px;
      }

      li.active {
        color: #4184d2;
        border-bottom: 2px solid #4184d2;
      }

    }
  }
}

.item_game {
  width: calc(100% - 20px);
  height: 84px;
  background: #FFFFFF;
  box-shadow: 0px 15px 25px 0px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  margin: 0 10px 10px 10px;
  position: relative;

  img {
    width: 57px;
    height: 57px;
    margin-top: 17px;
    margin-left: 19px;
    display: inline-block;
  }

  .title {
    height: 14px;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 14px;
    margin-top: 24px;
    margin-left: 11px;
    display: inline-block;
    position: absolute;
  }

  .tag {
    height: 12px;
    font-size: 13px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 14px;
    opacity: 0.8;
    display: inline-block;
    margin-left: 11px;
    margin-top: 45px;
    position: absolute;
  }

  .btn_get {
    width: 71px;
    height: 25px;
    position: absolute;
    right: 15px;
    top: 28px;
    background-image: url("../../assets/img/item_list_get.png");
    background-size: 100%;

    font-size: 11px;
    font-family: Source Han Sans HW SC;
    font-weight: bold;
    color: #4184D2;
    line-height: 25px;
    text-align: center;
  }
}


//社区部分
.community {
  height: 100%;
  padding-bottom: 80px;
  background:#fff;
  position: relative;
  margin-top: 50px;

  ul {
    width: 100%;
    height: 40px;
    overflow: hidden;
    box-shadow: 10px 5px 15px #f4f4f4;
    padding: 5px 0;
    position: fixed;
    background: #fff;
    top: 50px;
    z-index:10;

    li {
      float: left;
      height: 40px;
      width: 100px;
      margin-left: 10px;

      div {
        width: 90px;
        height: 29px;
        font-size: 14px;
        font-family: PingFang;
        font-weight: 500;
        line-height: 29px;
        text-align: center;
        margin: 0 auto;
        color: #333333;

        position: relative;
        top: 50%;
        transform: translateY(-50%);
        background-color: #F5F5F5 ;
        border-radius: 20px;
      }

      div.active {
        background-color: #29CD85;
        border-radius: 20px;
        color: white;
      }

    }


  }

  .add-trend {
    position: fixed;
    bottom: 100px;
    right: 15px;

    img {
      width: 44px;
      height: 44px;
    }
  }
}

</style>
